import { render, staticRenderFns } from "./ProduceDetail.vue?vue&type=template&id=15b30928&scoped=true"
import script from "./ProduceDetail.vue?vue&type=script&lang=js"
export * from "./ProduceDetail.vue?vue&type=script&lang=js"
import style0 from "./ProduceDetail.vue?vue&type=style&index=0&id=15b30928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b30928",
  null
  
)

export default component.exports